<template>
    <div class="content-404">
        <div class="logo">
            <img src="../assets/img/header/logo.png" alt="logo header" />
        </div>
        <div class="title">
            <div class="info">
                <h1>
                    ESTAMOS A PREPARAR O CAFÉ DA SORTE PARA SI
                </h1>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.content--offline {
  margin-top: 0px !important;
}
.content-404 {
    background-color: var(--main-color);
    height: 100vh;
    width: 100%;
    > .title {
        text-align: left;
        margin-top: 5rem;
        > .info {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            > h1 {
                color: #fff;
                text-align: center;
                font-family: "Font Regular";
                color: white;
                font-weight: 700;
                font-size: 25px;
                line-height: 50px;
                margin-bottom: 7rem;
                letter-spacing: 5px;
            }
        }
    }
}
</style>
